import state from './state';
import actions from './actions';
import mutations from './mutations';
import * as getters from './getters';

/**
 * This store is used for loading generic lists of data
 * to be used inside of form dropdowns, input autofills, and any
 * other component that share the same properties
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}; 